// Shared constants: contact info, booking URL, logo URL
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_d2e8da29-4ac0-442a-be4e-d2254d726751/artifacts/popx96nq_tra-logo-dark-Dl-SyHGl.png";

// Booking URL — Calendly link for the 15-minute tariff discovery call.
export const BOOKING_URL =
  "https://calendly.com/betsywbutters/15-minute-tariff-discovery";

export const CONTACT = {
  email: "stevenfsica@outlook.com",
  phone: "203-246-3191",
  phoneHref: "tel:2032463191",
  website: "tariffrecoveryagency.com/ref/stevensica",
  websiteHref: "https://tariffrecoveryagency.com/ref/stevensica",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1609972626304-96959161d195?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxjYXJnbyUyMHNoaXAlMjBwb3J0JTIwY29udGFpbmVyJTIwc3Vuc2V0fGVufDB8fHx8MTc4Mjk1MDk3N3ww&ixlib=rb-4.1.0&q=85";

export const FINANCIAL_ABSTRACT =
  "https://images.unsplash.com/photo-1513346940221-6f673d962e97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBncmFwaCUyMGFic3RyYWN0JTIwZ29sZHxlbnwwfHx8fDE3ODI5NTA5Nzd8MA&ixlib=rb-4.1.0&q=85";

export const SECTOR_MANUFACTURING =
  "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZmFjdG9yeSUyMG1hbnVmYWN0dXJpbmclMjB3YXJlaG91c2V8ZW58MHx8fHwxNzgyOTUwOTc3fDA&ixlib=rb-4.1.0&q=85";
